export class ProfileInfo {
  public static readonly defaultArenaName: string = 'Current';

  constructor(
    public readonly id: string,
    public readonly displayText: string,
    public readonly isCurrent?: boolean,
    public readonly settings?: any,
    public readonly mapImagePreview?: string,
    public readonly description?: string
  ) {}
}
